/*
 * Modules
 */

import CoherentBookingsModule from "./coherent-bookings";

/* Internal */
import BasketInternal from "./internal";

/* Internal Vars */
import BasketJar from "./jar";

/* Internal Services */
import BasketService from "./service";

/* Internal Storage */
import BasketStorage from "./storage";

/* Internal Factories */
import BasketFactory from "./factory";

/* Facades */
import Basket from "./facade";

const modul = angular

    .module("BasketModule", [CoherentBookingsModule])

    /**
     * Internal
     */
    .factory("BasketInternal", BasketInternal)

    /**
     * BasketJar
     */
    .service("BasketJar", BasketJar)

    /**
     * Services
     * * can only have utility dependencies
     */
    .factory("BasketService", BasketService)

    /**
     * Storage
     * can only have utility and services as dependencies
     */
    .factory("BasketStorage", BasketStorage)

    /**
     * Factories
     */
    .factory("BasketFactory", BasketFactory)

    /**
     * Facades
     */
    .factory("Basket", Basket);

export default modul.name;
